import { bloomScale } from "../../lib/questions";
import { QuestionStepShell } from "./QuestionStepShell";
import type { QuestionStepProps } from "./types";

const FACE_PATHS = [
  "M8 14c0-2 1.5-3 4-3s4 1 4 3",
  "M8 15c0-1 1.5-2 4-2s4 1 4 2",
  "M8 14c0 0 1.5 1 4 1s4-1 4-1",
  "M8 13c0 1 1.5 2 4 2s4-1 4-2",
  "M8 12c0 2 1.5 3 4 3s4-1 4-3",
];

/** Emotionele herkenning: gezicht + label per optie, alles tegelijk zichtbaar. */
export function QuestionStepFaces({
  question,
  questionIndex,
  totalQuestions,
  selectedValue,
  onSelect,
  onBack,
  canGoBack,
}: QuestionStepProps) {
  return (
    <QuestionStepShell
      question={question}
      questionIndex={questionIndex}
      totalQuestions={totalQuestions}
      selectedValue={selectedValue}
      onSelect={onSelect}
      onBack={onBack}
      canGoBack={canGoBack}
    >
      <div className="bloom-faces" role="group" aria-label="Antwoordopties">
        <div className="bloom-faces__row">
          {bloomScale.labels.map((label, index) => (
            <button
              key={index}
              type="button"
              className={`bloom-faces__btn${selectedValue === index ? " bloom-faces__btn--selected" : ""}`}
              aria-pressed={selectedValue === index}
              onClick={() => onSelect(index)}
            >
              <svg className="bloom-faces__svg" viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="12" cy="12" r="10" className="bloom-faces__circle" />
                <circle cx="9" cy="10" r="1.2" className="bloom-faces__eye" />
                <circle cx="15" cy="10" r="1.2" className="bloom-faces__eye" />
                <path d={FACE_PATHS[index]} className="bloom-faces__mouth" fill="none" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
              <span className="bloom-faces__option-label">{label}</span>
            </button>
          ))}
        </div>
      </div>
    </QuestionStepShell>
  );
}
